interface AuthConfig {
	clientID: string;
	domain: string;
	callbackURL: string;
    userInfoURL: string;
    memberRouter: string[];
    responseType: string;
}

export const AUTH_CONFIG: AuthConfig = {
	clientID: 'sHICIxCXNjlyr0tvHqxqRMb2PpO37cRd',
	domain: 'mobil-it-dev.eu.auth0.com',
	callbackURL: 'https://mobilit.coformatique.com/',
    userInfoURL: 'https://${AUTH_CONFIG.domain}/userinfo',
    memberRouter: ['/dashboard'],
    responseType: 'openid email'
};



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/config/auth0-variables.prod.ts